import { jsxs as l, jsx as e } from "react/jsx-runtime";
import f from "../../../../../../../hooks/useBreakpoint.js";
import "react";
import "../../../../../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import c from "../../../../../../layout/Stack/Stack.js";
import r from "../../../../../../layout/Box/Box.js";
import "styled-components";
import "../../../../../../../index-CZ8zjHGv.js";
import h from "../../../../../../layout/Center/Center.js";
import "../../../../../../layout/Columns/ColumnsContext.js";
import g from "../../../../../../typography/Text/Text.js";
import y from "../../../../../../typography/Heading/Heading.js";
import "../../../../../../../context/Text.js";
import "../../../../../../../context/Typography.js";
import "../../../../../../../hooks/link/index.js";
import n from "./components/ModalButton.js";
function O({
  children: d,
  noTopImageContainer: m
}) {
  const {
    topImage: o,
    title: a,
    subtitle: p,
    body: x,
    primaryButtonProps: i,
    secondaryButtonProps: t
  } = d, { isMobileOnly: s } = f();
  return /* @__PURE__ */ l(
    r,
    {
      minHeight: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "xxlarge",
      paddingX: ["none", "xxlarge"],
      paddingTop: ["xxlarge", "none"],
      children: [
        /* @__PURE__ */ l(
          r,
          {
            flex: "1 0",
            display: "flex",
            flexDirection: "column",
            gap: "xxlarge",
            justifyContent: "center",
            children: [
              (o || a) && /* @__PURE__ */ l(
                r,
                {
                  display: "flex",
                  flexDirection: "column",
                  gap: "20",
                  alignItems: "center",
                  children: [
                    o && /* @__PURE__ */ e(r, { width: m ? "100%" : ["200px", "160px"], children: /* @__PURE__ */ e(h, { children: o }) }),
                    a && /* @__PURE__ */ e(r, { maxWidth: "400px", children: /* @__PURE__ */ e(y, { level: "3", align: "center", children: a }) })
                  ]
                }
              ),
              p && /* @__PURE__ */ e(g, { lineHeight: "large", align: "center", children: /* @__PURE__ */ e(c, { space: "12", children: p }) }),
              x
            ]
          }
        ),
        (i || t) && /* @__PURE__ */ e(r, { flex: "0", children: s ? /* @__PURE__ */ l(c, { space: "xlarge", children: [
          i && /* @__PURE__ */ e(n, { ...i, cta: "primary" }),
          t && /* @__PURE__ */ e(n, { ...t, cta: "secondary" })
        ] }) : /* @__PURE__ */ e(r, { width: "100%", children: i && t ? /* @__PURE__ */ l(
          r,
          {
            display: "flex",
            gap: "xlarge",
            flexWrap: "wrap-reverse",
            whiteSpace: "nowrap",
            children: [
              /* @__PURE__ */ e(r, { flex: "1 0 208px", children: /* @__PURE__ */ e(n, { ...t, cta: "secondary" }) }),
              /* @__PURE__ */ e(r, { flex: "1 0 208px", children: /* @__PURE__ */ e(n, { ...i, cta: "primary" }) })
            ]
          }
        ) : /* @__PURE__ */ e(r, { display: "flex", flexDirection: "column", alignItems: "center", children: /* @__PURE__ */ e(r, { minWidth: "208px", children: i ? /* @__PURE__ */ e(n, { ...i, cta: "primary" }) : t ? /* @__PURE__ */ e(n, { ...t, cta: "secondary" }) : null }) }) }) })
      ]
    }
  );
}
export {
  O as default
};
